"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParent = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "getParent", { enumerable: true, get: function () { return dom_utilities_1.getParent; } });
//# sourceMappingURL=getParent.js.map